import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/billing/"
)({
  component: () => (
    <Navigate
      to="/organization-settings/billing/$tabKey"
      params={{ tabKey: "details" }}
    />
  ),
})
